import React from "react";
import chart from '../../Images/chart.svg';
import "./Chatbot.css";

function DashboardContent() {
  return (
    <>
      <div className="row d-flex justify-content-center mb-4 disabled-container">
        <div
          className="col-8 d-flex flex-row"
          style={{ justifyContent: "space-around", gap: "10px" }}
        >
          <div className="col-md-3" style={{ width: "275px" }}>
            <div
              className="card shadow-sm text-center rounded-circle"
              style={{ height: "60px", width: "100%" }}
            >
              <div
                className="card-body d-flex align-items-center"
                style={{
                  height: "100%",
                  backgroundColor: "white",
                  borderRadius: "10px",
                }}
              >
                <div
                  className="d-flex justify-content-center align-items-center rounded me-3"
                  style={{
                    width: "75px",
                    height: "50px",
                    backgroundColor: "#FFFBA6",
                  }}
                >
                  <img
                    src={chart}
                    alt="Asset Icon"
                    style={{ width: "24px", height: "24px" }}
                  />
                </div>
                <h5 className="mb-0">Asset Performance Dashboard</h5>
              </div>
            </div>
          </div>

          <div className="col-md-3" style={{ width: "275px" }}>
            <div
              className="card shadow-sm text-center"
              style={{ height: "60px", width: "100%" }}
            >
              <div
                className="card-body d-flex align-items-center"
                style={{
                  height: "100%",
                  backgroundColor: "white",
                  borderRadius: "10px",
                }}
              >
                <div
                  className="d-flex justify-content-center align-items-center rounded me-3"
                  style={{
                    width: "75px",
                    height: "50px",
                    backgroundColor: "#A6E9FF",
                  }}
                >
                  <img
                    src={chart}
                    alt="Client Icon"
                    style={{ width: "24px", height: "24px" }}
                  />
                </div>
                <h5 className="mb-0">Client Performance Dashboard</h5>
              </div>
            </div>
          </div>

          <div className="col-md-3" style={{ width: "275px" }}>
            <div
              className="card shadow-sm text-center"
              style={{ height: "60px", width: "100%" }}
            >
              <div
                className="card-body d-flex align-items-center"
                style={{
                  height: "100%",
                  backgroundColor: "white",
                  borderRadius: "10px",
                }}
              >
                <div
                  className="d-flex justify-content-center align-items-center rounded me-3"
                  style={{
                    width: "75px",
                    height: "50px",
                    backgroundColor: "#A6FFAF",
                  }}
                >
                  <img
                    src={chart}
                    alt="Index Icon"
                    style={{ width: "24px", height: "24px" }}
                  />
                </div>
                <h5 className="mb-0">Index Performance Dashboard</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DashboardContent;
